import { Validator } from '@vista-digital/validator';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { logger } from '../../../../utils/logger';
import { orderBookingModeValidator } from '../../../../utils/validators/order-booking-mode';
import { nonEmptyStringValidator } from '../../../../utils/validators/string';
import { getOrder } from '../../selectors/order/get-order';
import { getOrderSelections } from '../../selectors/order/get-order-selections';
import { assertIsOrderNotCreated } from '../../utils/order-type-utils';
import { registerOrderAction } from '../utils/register-order-action';
import { syncOrder } from '../utils/sync-order';
export const createStandardOrder = async (siteId, bookingMode) => {
    const order = getOrder();
    const orderSelections = getOrderSelections();
    assertIsOrderNotCreated(order, 'Cannot create standard order');
    if (!nonEmptyStringValidator(siteId, logger.error, 'createStandardOrder siteId')) {
        throw new Error('Cannot create standard order. Provided siteId is invalid.');
    }
    if (!Validator.optional(orderBookingModeValidator)(bookingMode, logger.error, 'createStandardOrder bookingMode')) {
        throw new Error('Cannot create standard order. Provided bookingMode is invalid.');
    }
    const deregisterAction = registerOrderAction('create-standard-order');
    try {
        const response = await ocapiClient.instance.v1.orders.create.standard({
            siteId,
            bookingMode: bookingMode || orderSelections.bookingMode
        });
        syncOrder(response);
        return response.order;
    }
    finally {
        deregisterAction();
    }
};
